export default "__VITE_ASSET__55c8d631__"